import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';

import {
  changeShippingAddress,
  resetShippingForm,
  updateMailingAddressOrName,
  updateShippingPhone
} from 'actions/account/shipping';
import { firePixelServer } from 'actions/pixelServer';
import AccountHeader from 'containers/account/AccountHeader';
import Breadcrumb from 'components/account/Breadcrumb';
import BackNav from 'components/account/BackNav';
import SiteAwareMetadata from 'components/SiteAwareMetadata';
import ShippingForm from 'components/account/ShippingForm';
import { reverseReturnUrlLookup } from 'helpers/MyAccountUtils';
import styles from 'styles/containers/account/addShipping.scss';

const items = [
  { name: 'Shipping Information', url: '/addresses' },
  { name: 'Add New Address' }
];

export class AddShipping extends Component {
  componentDidMount() {
    const { firePixelServer } = this.props;
    firePixelServer('my-account', {}, 'addresses-add');
  }

  render() {
    const {
      location: { search },
      shipping,
      changeShippingAddress,
      updateMailingAddressOrName,
      updateShippingPhone,
      resetShippingForm
    } = this.props;

    const { returnTo } = queryString.parse(search);
    const isValidReturnUrl = !!reverseReturnUrlLookup(returnTo);

    return (
      <SiteAwareMetadata>
        <div className={styles.addShipping}>
          <Breadcrumb items={items}/>
          <BackNav to={isValidReturnUrl ? returnTo : '/addresses'}>
            {isValidReturnUrl ? reverseReturnUrlLookup(returnTo) : 'Shipping Information'}
          </BackNav>
          <AccountHeader title="Add New Address" showCustomerEmail={false}/>
          <ShippingForm
            shipping={shipping}
            returnTo={returnTo}
            onChangeShippingAddress={changeShippingAddress}
            onUpdateMailingAddressOrName={updateMailingAddressOrName}
            onUpdateShippingPhone={updateShippingPhone}
            onResetShippingForm={resetShippingForm} />
        </div>
      </SiteAwareMetadata>
    );
  }
}

AddShipping.contextTypes = {
  testId: PropTypes.func
};

const mapStateToProps = state => ({
  shipping: state.shipping
});

export default connect(mapStateToProps, {
  firePixelServer,
  resetShippingForm,
  changeShippingAddress,
  updateMailingAddressOrName,
  updateShippingPhone
})(AddShipping);
